module.exports = __webpack_public_path__ + "static/media/butler-with-champagne.4f2b0f49.jpg";